import React from 'react'

import { ReactComponent as MMAvatar } from './assets/avatars/mm_white.svg'
import { ReactComponent as LlamayaAvatar } from './assets/avatars/ya.svg'
// import { ReactComponent as YoigoAvatar } from './assets/avatars/yoigo.svg'
import { ReactComponent as LlamayaLogo } from './assets/logos/llamaya.svg'
import { ReactComponent as MMLogo } from './assets/logos/masmovil.svg'
// import { ReactComponent as YoigoLogo } from './assets/logos/yoigo.svg'

interface Brand {
  [key: string]: {
    id: string
    logo: React.ReactNode
    avatar: React.ReactNode
  }
}

const Brands: Brand = {
  masmovil: {
    id: 'masmovil',
    logo: <MMLogo />,
    avatar: <MMAvatar />,
  },
  llamaya: {
    id: 'llamaya',
    logo: <LlamayaLogo />,
    avatar: <LlamayaAvatar />,
  },
  // yoigo: {
  //   logo: <YoigoLogo />,
  //   avatar: <YoigoAvatar />,
  // },
}

export default Brands
